/** Agent cursors on the screen: status bubbles, questions, the avatar dock
 *  card and the presentation guide. */
export default {
  agentFallbackName: "Agent",
  agentThinking: "{agentName} is thinking",
  thinkingPondering: "Pondering",
  thinkingPontificating: "Pontificating",
  thinkingHarmonizing: "Harmonizing",
  thinkingConjuring: "Conjuring",
  thinkingMarinating: "Marinating",
  thinkingPercolating: "Percolating",
  thinkingSimmering: "Simmering",
  thinkingNoodling: "Noodling",
  thinkingRuminating: "Ruminating",
  thinkingDistilling: "Distilling",
  thinkingCrystallizing: "Crystallizing",
  thinkingUntangling: "Untangling",
  toolFailed: "Tool failed",
  collapseReply: "Collapse reply",
  expandReply: "Expand reply",
  dismissCursor: "Dismiss cursor",
  closeAnnotation: "Close drawing and callout",
  stalledNoReply: "No reply for {duration}",
  durationSeconds: "{seconds}s",
  durationMinutes: "{minutes}m",
  durationMinutesSeconds: "{minutes}m {seconds}s",
  switchModel: "Switch model",
  questionBadgeLabel: "{agentName} has a question: open it",
  question: "Question",
  answerSent: "✓ sent",
  otherAnswer: "Other",
  answerByVoice: "Answer by voice",
  typeAnotherAnswer: "Type another answer",
  send: "Send",
  stopAgent: "Stop agent",
  stop: "Stop",
  followUp: "Follow-up",
  askFollowUpByVoice: "Ask follow-up by voice",
  typeFollowUp: "Type follow-up",
  showDeliverables: "Show deliverables",
  guideCueClick: "Click here",
  guideCueType: "Type here",
  guideCueEnter: "Press Enter",
  guideCueDrag: "Drag along the arrow",
  guideCueFallback: "Do this action",
  guideControlsLabel: "Presentation guide controls",
  guideStep: "Step {current} of {total}",
  guidePaused: "Paused",
  guideYourTurn: "Your turn",
  guideGuiding: "Guiding you",
  guideHintPaused: "Take your time. Resume repeats this instruction.",
  guideHintWaiting: "{action}, or confirm when done.",
  guideHintGuiding: "Pause anytime to try it yourself.",
  guideResume: "Resume",
  guidePause: "Pause",
  guideShowAgain: "Show again",
  guideDoneContinue: "Done, continue",
  guideEnd: "End guide",
} as const;
